import * as React from 'react';
export const pwcSvg = React.forwardRef(function pwcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#ED6309',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M20.14 19.57c-.79.13-1.2.73-1.2 1.77 0 1.05.55 1.74 1.37 1.74.39 0 .74-.12 1.46-.48v.85c-.88.4-1.39.53-2.1.53-.77 0-1.3-.21-1.75-.67a2.43 2.43 0 0 1-.68-1.73c0-1.5 1.1-2.52 2.7-2.52 1.06 0 1.8.5 1.8 1.21 0 .48-.35.8-.86.8-.26 0-.47-.08-.74-.24v-1.26m-8.45-.48c.08.34.11.6.12.8l.1 2.33 1.36-2.63v-.27l1.4-.12.17 3.63 1.2-1.71-.26-1.76c.25-.22.43-.3.71-.3.46 0 .76.3.76.74 0 .47-.25 1.02-.87 1.91-.2.28-.77 1.01-1.71 2.2h-1.1l-.2-3.29-1.74 3.28h-1.18l.1-.43-.15-3.45-.92-.15v-.38l1.68-.4h.53M6.2 23.3l.26.02c.95 0 1.46-.61 1.46-1.75 0-.98-.42-1.5-1.19-1.5-.13 0-.26.02-.52.06v3.17zm-2.17 2.2.53-.04.1-.13V20.1H4v-.46l1.71-.56h.49v.64c.85-.52 1.18-.65 1.62-.65 1.02 0 1.8 1 1.8 2.3 0 1.52-1.07 2.54-2.65 2.54a9.2 9.2 0 0 1-.77-.05v1.47l.12.13.6.04-.01.51h-2.9v-.5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FBFBFB',
        d: 'M14.77 16.377h4.533v-1.23H14.77z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4A775',
        d: 'M19.303 8.024h4.434v-.975h-4.434z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F29355',
        d: 'M23.737 9.433h.822V8.024h-.822z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F8C29F',
        d: 'M19.303 9.433h4.434V8.024h-4.434z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F39B61',
        d: 'M24.559 12.918H26.8V9.433h-2.241z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6B489',
        d: 'M23.737 12.918h.822V9.433h-.822z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FAD4BC',
        d: 'M22.043 12.918h1.694V9.433h-4.434v2.332h2.74v1.153',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6B58B',
        d: 'M26.8 15.147h1.195v-2.229H26.8z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F9CBAD',
        d: 'M24.559 15.147H26.8v-2.229h-2.241z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FAD4BC',
        d: 'M23.737 15.147h.822v-2.229h-.822z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCE7DA',
        d: 'M22.043 15.147h1.694v-2.229h-1.694zm-2.74-2.229h2.74v-1.153h-2.74z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FDF2EB',
        d: 'M19.303 15.147h2.74v-2.229h-2.74z',
      }),
    ),
  );
});
pwcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var pwc = {
  category: 'brand',
  colorable: false,
  name: 'pwc',
  svg: pwcSvg,
};
